<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: Georgia, "Times New Roman", Times, serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.modal__content {
    height: 45vh;
}

.action-btn
  {
    width: 75px;
  }

  .modal-xl {
    max-width: 1500px !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue